<template>
    <v-layout style="box-shadow: 0 0.5mm 2mm rgba(0, 0, 0, .3);height: 100%;overflow: hidden;padding: 0px;margin: 0px;">
        <v-container
                style="padding: 0px;margin: 0px;width: 400px;flex-shrink: 0;overflow: auto;max-height:720px;">
            <v-simple-form title="">
                <template v-slot:toolbar>
                    <v-btn text tile small color="rgba(0,0,0,.7)" @click="goBack">
                        <v-icon color="gray">mdi-step-backward</v-icon>
                        返回
                    </v-btn>
                    <v-btn text tile small color="rgba(0,0,0,.7)">
                        <v-icon color="gray">mdi-content-save</v-icon>
                        保存
                    </v-btn>
                    <v-btn :loading="$store.getters.loading['DOC_DOWNLOAD']" text tile small color="rgba(0,0,0,.7)"
                           @click="onRefresh">
                        <v-icon color="gray">mdi-refresh</v-icon>
                        刷新
                    </v-btn>
                    <v-spacer/>
                </template>
                <template v-slot:content>
                    <v-form-selector
                            vertical
                            :label-width="70"
                            :field-width="300"
                            items="文档|document,页面|page,版心|content,段落|block"
                            label="相对位置" v-model="dataItem.relativeFrom"></v-form-selector>

                    <v-form-selector
                            vertical
                            :label-width="70"
                            :field-width="300"
                            items="块|block,段落|paragraph,图片|image,图形(线)|graphic"
                            label="组件类型" v-model="dataItem.type"></v-form-selector>

                    <v-form-selector
                            v-if="dataItem.type=='graphic'"
                            vertical
                            :label-width="70"
                            :field-width="300"
                            items="直线|line,五角星|star,双线(文武线)|double1,双线(武文线)|double2"
                            label="线类型" v-model="dataItem.graphic.type"></v-form-selector>


                    <v-form-textarea :field-width="300" :height="50" vertical v-model="dataItem.text"
                                     label="文本"></v-form-textarea>


                    <v-form-selector
                            label="长度单位"
                            vertical
                            :field-width="300"
                            items="毫米|mm,磅|pt" v-model="dataItem.top.unit"></v-form-selector>

                    <v-layout>
                        <v-form-field :field-width="70" vertical :label-width="70" v-model="dataItem.top.size"
                                      label="上">
                            <template v-slot:append>
                                <v-btn small icon color="primary" @click="plus('top.size')">
                                    <v-icon>mdi-plus-circle</v-icon>
                                </v-btn>
                                <v-btn small icon color="primary" @click="minus('top.size')">
                                    <v-icon>mdi-minus-circle</v-icon>
                                </v-btn>
                            </template>
                        </v-form-field>

                        <v-form-field :field-width="70" vertical :label-width="70" v-model="dataItem.left.size"
                                      label="左">
                            <template v-slot:append>
                                <v-btn small icon color="primary" @click="plus('left.size')">
                                    <v-icon>mdi-plus-circle</v-icon>
                                </v-btn>
                                <v-btn small icon color="primary" @click="minus('left.size')">
                                    <v-icon>mdi-minus-circle</v-icon>
                                </v-btn>
                            </template>
                        </v-form-field>
                    </v-layout>


                    <v-layout>
                        <v-form-field :field-width="70" vertical :label-width="70" v-model="dataItem.bottom.size"
                                      label="下">
                            <template v-slot:append>
                                <v-btn small icon color="primary" @click="plus('bottom.size')">
                                    <v-icon>mdi-plus-circle</v-icon>
                                </v-btn>
                                <v-btn small icon color="primary" @click="minus('bottom.size')">
                                    <v-icon>mdi-minus-circle</v-icon>
                                </v-btn>
                            </template>
                        </v-form-field>

                        <v-form-field :field-width="70" vertical :label-width="70" v-model="dataItem.right.size"
                                      label="右">
                            <template v-slot:append>
                                <v-btn small icon color="primary" @click="plus('right.size')">
                                    <v-icon>mdi-plus-circle</v-icon>
                                </v-btn>
                                <v-btn small icon color="primary" @click="minus('right.size')">
                                    <v-icon>mdi-minus-circle</v-icon>
                                </v-btn>
                            </template>
                        </v-form-field>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-form-selector
                            vertical
                            :label-width="70"
                            :field-width="300"
                            items="仿宋_GB2312,楷体_GB2312,方正小标宋简体,黑体"
                            label="字体" v-model="dataItem.font"></v-form-selector>
                    <v-form-selector
                            vertical
                            :label-width="70"
                            :field-width="300"
                            number-value
                            items="16pt|16.0,22pt|22.0,24pt|24.0,48pt|48.0"
                            label="字体大小" v-model="dataItem.fontSize.size"></v-form-selector>
                    <v-layout>
                        <v-form-selector
                                vertical
                                :label-width="70"
                                :field-width="110"
                                items="左|left,居中|center,右|right,两边对齐|justify"
                                label="对齐方式" v-model="dataItem.align"></v-form-selector>
                        <v-form-selector
                                vertical
                                :label-width="70"
                                :field-width="110"
                                items="红色|red,黑色|black"
                                label="颜色" v-model="dataItem.color"></v-form-selector>
                    </v-layout>
                    <v-form-selector
                            vertical
                            float-value
                            :label-width="70"
                            :field-width="300"
                            items="40%|0.4,55%|0.55,50%|0.5,60%|0.6,66%|0.66,70%|0.7,80%|0.8,90%|0.9,无|1"
                            label="缩放" v-model="dataItem.scale"></v-form-selector>
                </template>
            </v-simple-form>
        </v-container>
        <v-container class="ma-0 pa-0" style="padding: 0px;margin: 0px;">
            <div v-html="html">
            </div>
        </v-container>
    </v-layout>
</template>

<script>

    export default {
        name: "TypeEngine.vue",
        data() {
            return {
                html: null,
                docHtml: null,
                docId: null,
                elements: [],
                page: {
                    top: {
                        size: 0,
                        unit: 'mm'
                    },
                    left: {
                        size: 0,
                        unit: 'mm'
                    },
                    bottom: {
                        size: 0,
                        unit: 'mm'
                    },
                    right: {
                        size: 0,
                        unit: 'mm'
                    },
                    paper: null
                },
                dataItem: {
                    id: null,
                    relativeFrom: null,
                    top: {
                        size: 0,
                        unit: 'mm'
                    },
                    left: {
                        size: 0,
                        unit: 'mm'
                    },
                    bottom: {
                        size: 0,
                        unit: 'mm'
                    },
                    right: {
                        size: 0,
                        unit: 'mm'
                    },
                    fontName: "仿宋_GB2312",
                    fontSize: 16,
                    graphic: {
                        type: null,
                        height: {
                            size: 1,
                            unit: 'mm'
                        }
                    }
                },
                defaultDataItem: {
                    id: null,
                    relativeFrom: null,
                    top: {
                        size: 0,
                        unit: 'mm'
                    },
                    left: {
                        size: 0,
                        unit: 'mm'
                    },
                    bottom: {
                        size: 0,
                        unit: 'mm'
                    },
                    right: {
                        size: 0,
                        unit: 'mm'
                    },
                    fontName: "仿宋_GB2312",
                    fontSize: {
                        size: 16,
                        unit: 'pt'
                    }
                }
            }
        },
        created() {
            window.theApp.$emit("APP_DRAWER_TOGGLED");
            this.docId = this.$route.query.id;
            //  if (this.docId) {
            this.queryDetail(this.docId);
            let _this = this;
            window.selectElement = _this.selectElement;
            //  }
        },
        methods: {
            goBack() {
                this.$router.go(-1);
            },

            plus(attribute) {
                this.dataItem[attribute] = this.dataItem[attribute] + 1;
                this.onConvert();
            },

            minus(attribute) {
                this.dataItem[attribute] = this.dataItem[attribute] - 1;
                this.onConvert();
            },

            queryDetail(id) {
                this.$request
                    .request("DOC_TEMPLATE_DETAIL", {rowid: id})
                    .then(response => {
                        this.page = Object.assign(this.page, response.data.page);
                        this.elements = response.data.elements;
                        this.dataItem = Object.assign(this.dataItem, this.elements[0])

                        this.$request
                            .request("DOC_TEMPLATE_HTML", response.data)
                            .then(resp => {
                                this.html = resp.data;
                            });


                    });
            },
            onEdit() {
                window.open("/editor.html?type=fullHtml&id=" + this.docId, '_blank');
            },
            onRefresh() {
                let param = {
                    page: this.page,
                    elements: this.elements
                }
                this.$request
                    .request("DOC_TEMPLATE_HTML", param)
                    .then(resp => {
                        this.html = resp.data;
                    });
            },
            selectElement(index, subIndex) {
                console.log("subIndex===>" + subIndex);
                let element = this.elements[index];
                if (subIndex != undefined) {
                    element = element.layout[subIndex];
                }
                if (!element.top) {
                    element.top = Object.create(null);
                }
                if (!element.left) {
                    element.left = Object.create(null);
                }
                if (!element.right) {
                    element.right = Object.create(null);
                }
                if (!element.bottom) {
                    element.bottom = Object.create(null);
                }
                if (!element.fontSize) {
                    element.fontSize = Object.create(null);
                }
                this.dataItem = element;
                //this.dataItem=Object.assign(this.dataItem, element);
            }
        }
    }
</script>